import { getTenantId } from '@/services/apiClient';

/**
 * Returns true when the logged-in user has access to only one tenant.
 * Detection: if the JWT does not contain a tenantId claim,
 * getTenantId() will be null — meaning single-tenant access.
 */
export function isSingleTenant(): boolean {
  return !getTenantId();
}

export function useSingleTenant(): boolean {
  return isSingleTenant();
}
